import Error404 from "../components/NotFound/Error404"

export default function NotFound() {
    return (
        <Error404 />
    )
}